import {memo} from "react";
import "./StreetViewAlertModal.css";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import { toSafeSimpleHtml } from "../../utils/safeHtml.js";
import { TbMapSearch } from "react-icons/tb";
import { ArrowRight } from "lucide-react";
import { X } from "lucide-react";

const StreetViewAlertModal = ({ visible, message, onConfirm, onCancel }) => {
  useEscapeKey(() => onCancel(), visible);

  if (!visible) return null;

  const strMessage = toSafeSimpleHtml(message);

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <TbMapSearch size={22} />
            <h2>Street View</h2>
          </div>{" "}
          <button className="modal-close" onClick={onCancel}>
            <X size={20} strokeWidth={2}/>
          </button>
        </div>
        <p
          className="modal-message"
          dangerouslySetInnerHTML={{ __html: strMessage }}
        />
        <div className="modal-actions">
          <button className="modal-button" onClick={onConfirm}>
            POURSUIVRE <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

// Comparaison personnalisée pour éviter les re-renders inutiles
const arePropsEqual = (prevProps, nextProps) => {
  // Seuls ces 3 props nous intéressent
  return (
    prevProps.visible === nextProps.visible &&
    prevProps.message === nextProps.message &&
    prevProps.onConfirm === nextProps.onConfirm &&
    prevProps.onCancel === nextProps.onCancel
  );
};

export default memo(StreetViewAlertModal, arePropsEqual);
